export default __webpack_public_path__ + "static/media/task-reward-title.bc82c24b.png";